module.exports = __webpack_public_path__ + "img/EinRißGehtDurchUnsereGesellschaft.8125e2b6.jpg";